<template>
  <div class="main">
    <div class="col-gauche">
      <img src="../assets/overlayLogin.png" alt="image emotion culturel" />
    </div>
    <div class="col-droite">
      <form autocomplete="off" @submit="onSubmit">
        <div class="field">
          <label for="courriel">Adresse courriel<span>*</span></label>
          <input
            type="email"
            v-model="form.email"
            name="courriel"
            id="courriel"
            disabled
            placeholder="Adresse courriel*"
            required
          />
        </div>

        <div class="field">
          <div class="passwordCtn">
            <label for="password">Mot de passe</label>
            <input
              class="password"
              v-model="form.password"
              :type="passwordSecret"
              name="password"
              id="password"
              placeholder="Créer votre mot de passe*"
              autocomplete="current-password"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>

        <div class="field">
          <div class="passwordCtn">
            <label for="password_verif"
              >Confirmation de votre mot de passe</label
            >
            <input
              class="password"
              v-model="form.confirmPassword"
              :type="passwordSecret"
              name="password"
              id="password_verif"
              placeholder="Confirmation de votre mot de passe*"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>
        <input class="btn-submit" type="submit" value="Créer un compte" />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      passwordSecret: "password",
      form: {},
    };
  },
  methods: {
    switchPasswordSecret(state) {
      if (state == "visible") {
        this.passwordSecret = "text";
      }
      if (state == "invisible") {
        this.passwordSecret = "password";
      }
    },
    ...mapActions(["resetPassword"]),
    onSubmit(event) {
      event.preventDefault();
      if (this.form.confirmPassword === this.form.password) {
        this.resetPassword({
          token: this.form.token,
          password: this.form.password,
        });
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  created() {
    this.form.email = this.$route.query.email;
    this.form.token = this.$route.query.token;
  },
};
</script>

<style scoped src="../assets/styleLogin.css"></style>
